import _typeof from "D:/androidcode/zf_tms_vue/tms_vue/node_modules/@babel/runtime/helpers/esm/typeof.js";
import "core-js/modules/web.dom.iterable";
var defaults = {
  title: null,
  message: '',
  type: '',
  iconClass: '',
  showInput: false,
  showClose: true,
  modalFade: true,
  lockScroll: true,
  closeOnClickModal: true,
  closeOnPressEscape: true,
  closeOnHashChange: true,
  inputValue: null,
  inputPlaceholder: '',
  inputType: 'text',
  inputPattern: null,
  inputValidator: null,
  inputErrorMessage: '',
  showConfirmButton: true,
  showCancelButton: false,
  confirmButtonPosition: 'right',
  confirmButtonHighlight: false,
  cancelButtonHighlight: false,
  confirmButtonText: '',
  cancelButtonText: '',
  confirmButtonClass: '',
  cancelButtonClass: '',
  customClass: '',
  beforeClose: null,
  dangerouslyUseHTMLString: false,
  center: false,
  roundButton: false,
  distinguishCancelAndClose: false
};
import Vue from 'vue';
import msgboxVue from "./main.vue";
import merge from 'element-ui/lib/utils/merge';
import { isVNode } from 'element-ui/lib/utils/vdom';
import screenfull from 'screenfull';
import store from '@/store';
var MessageBoxConstructor = Vue.extend(msgboxVue);
var currentMsg, instance;
var msgQueue = [];
var defaultCallback = function defaultCallback(action) {
  if (currentMsg) {
    var callback = currentMsg.callback;
    if (typeof callback === 'function') {
      if (instance.showInput) {
        callback(instance.inputValue, action);
      } else {
        callback(action);
      }
    }
    if (currentMsg.resolve) {
      if (action === 'confirm') {
        if (instance.showInput) {
          currentMsg.resolve({
            value: instance.inputValue,
            action: action
          });
        } else {
          currentMsg.resolve(action);
        }
      } else if (currentMsg.reject && (action === 'cancel' || action === 'close')) {
        currentMsg.reject(action);
      }
    }
  }
};
var initInstance = function initInstance() {
  instance = new MessageBoxConstructor({
    el: document.createElement('div')
  });
  instance.callback = defaultCallback;
};
var _showNextMsg = function showNextMsg() {
  if (!instance) {
    initInstance();
  }
  instance.action = '';
  if (!instance.visible || instance.closeTimer) {
    if (msgQueue.length > 0) {
      currentMsg = msgQueue.shift();
      var options = currentMsg.options;
      for (var prop in options) {
        if (options.hasOwnProperty(prop)) {
          instance[prop] = options[prop];
        }
      }
      if (options.callback === undefined) {
        instance.callback = defaultCallback;
      }
      var oldCb = instance.callback;
      instance.callback = function (action, instance) {
        oldCb(action, instance);
        _showNextMsg();
      };
      if (isVNode(instance.message)) {
        instance.$slots.default = [instance.message];
        instance.message = null;
      } else {
        delete instance.$slots.default;
      }
      ['modal', 'showClose', 'closeOnClickModal', 'closeOnPressEscape', 'closeOnHashChange'].forEach(function (prop) {
        if (instance[prop] === undefined) {
          instance[prop] = true;
        }
      });
      if (store.state.settings.fullscreenDom != null && screenfull.isFullscreen) {
        console.error('掉一次');
        store.state.settings.fullscreenDom.appendChild(instance.$el);
      } else {
        console.error('掉x次');
        document.body.appendChild(instance.$el);
      }
      Vue.nextTick(function () {
        instance.visible = true;
      });
    }
  }
};
var _MessageBox = function MessageBox(options, callback) {
  if (Vue.prototype.$isServer) return;
  if (typeof options === 'string' || isVNode(options)) {
    options = {
      message: options
    };
    if (typeof arguments[1] === 'string') {
      options.title = arguments[1];
    }
  } else if (options.callback && !callback) {
    callback = options.callback;
  }
  if (typeof Promise !== 'undefined') {
    return new Promise(function (resolve, reject) {
      // eslint-disable-line
      msgQueue.push({
        options: merge({}, defaults, _MessageBox.defaults, options),
        callback: callback,
        resolve: resolve,
        reject: reject
      });
      _showNextMsg();
    });
  } else {
    msgQueue.push({
      options: merge({}, defaults, _MessageBox.defaults, options),
      callback: callback
    });
    _showNextMsg();
  }
};
_MessageBox.setDefaults = function (defaults) {
  _MessageBox.defaults = defaults;
};
_MessageBox.alert = function (message, title, options) {
  if (_typeof(title) === 'object') {
    options = title;
    title = '';
  } else if (title === undefined) {
    title = '';
  }
  return _MessageBox(merge({
    title: title,
    message: message,
    $type: 'alert',
    closeOnPressEscape: false,
    closeOnClickModal: false
  }, options));
};
_MessageBox.confirm = function (message, title, options) {
  if (_typeof(title) === 'object') {
    options = title;
    title = '';
  } else if (title === undefined) {
    title = '';
  }
  return _MessageBox(merge({
    title: title,
    message: message,
    $type: 'confirm',
    showCancelButton: true
  }, options));
};
_MessageBox.prompt = function (message, title, options) {
  if (_typeof(title) === 'object') {
    options = title;
    title = '';
  } else if (title === undefined) {
    title = '';
  }
  return _MessageBox(merge({
    title: title,
    message: message,
    showCancelButton: true,
    showInput: true,
    $type: 'prompt'
  }, options));
};
_MessageBox.close = function () {
  instance.doClose();
  instance.visible = false;
  msgQueue = [];
  currentMsg = null;
};
export default _MessageBox;
export { _MessageBox as MessageBox };